import { Component, OnInit } from '@angular/core'
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { Router } from '@angular/router'
import { CommonService } from '../../../../shared/services/common.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-single-quote-dialog',
  templateUrl: './single-quote-dialog.component.html',
  styleUrls: ['./single-quote-dialog.component.scss'],
})
export class SingleQuoteDialogComponent implements OnInit {
  iconTypes = ICON_TYPE
  // @ViewChild('dialog', { read: ElementRef })
  productObj: any

  constructor(
    protected launchDialogService: LaunchDialogService,
    public router: Router,
    public commonService: CommonService
  ) {}

  getProductImageUrl(productObj) {
    //Code to decide the URL for the image based on response
    if (
      productObj != undefined &&
      productObj.product != undefined &&
      productObj.product.images != undefined
    ) {
      return productObj?.product?.images[0]
    } else if (productObj != undefined && productObj.product != undefined) {
      return productObj?.product?.url
    } else {
      return ''
    }
  }

  ngOnInit() {
    this.fetchProductInformation()
  }

  fetchProductInformation() {
    this.commonService.getProduct.subscribe((product) => {
      this.productObj = product
    })
  }

  dismissModal(reason?: any): void {
    if (reason != 'Continue Shopping' && reason != 'Cross click') {
      this.router.navigate(['quote/cart'])
    }
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.SINGLE_QUOTE,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
